import PropTypes from "prop-types";

const CustomtabsType = {
  activeTab: PropTypes.string,
  handleChange: PropTypes.func,
  tabsList: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

export default CustomtabsType;
